import React from 'react';
export function FooterSection() {
  return <section className="bg-nero-card py-12 border-t-2 border-soft-gold" data-id="element-80">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-81">
        <h2 className="text-soft-gold text-2xl font-bold tracking-widest mb-2 font-playfair" data-id="element-82">
          NEROVIX™
        </h2>
        <p className="text-secondary-text text-sm mb-8" data-id="element-83">
          The #1 Business System for Personal Trainers in NZ/AU
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-xs text-gray-500 mb-8" data-id="element-84">
          <a href="#" className="hover:text-soft-gold transition-colors" data-id="element-85">
            Terms & Conditions
          </a>
          <a href="#" className="hover:text-soft-gold transition-colors" data-id="element-86">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-soft-gold transition-colors" data-id="element-87">
            Contact Us
          </a>
        </div>

        <p className="text-gray-600 text-xs mb-6" data-id="element-88">
          © {new Date().getFullYear()} NEROVIX™. All rights reserved.
          <br data-id="element-89" />
          This site is not a part of the Facebook website or Facebook Inc.
          Additionally, This site is NOT endorsed by Facebook in any way.
          FACEBOOK is a trademark of FACEBOOK, Inc.
        </p>

        <p className="text-soft-gold/50 italic text-xs font-playfair" data-id="element-90">
          "Build the system. Build the business."
        </p>
      </div>
    </section>;
}